module.exports = __webpack_public_path__ + "img/Bear10.2a54215b.jpg";